<!-- 
Contents of the HISTORY tab of the levy collection provider page.
-->
<template>
  <div>
    <our-heading 
      :breadcrumbs="breadcrumbs"
      :title="title" 
      :subtitle="subtitle" 
      user-guide-topic="levy-collection-providers"
      user-guide-section="history"
    >
      <template v-slot:additional-nav>
        <div class="hidden-md-and-down" style="position:relative;top:-4px;">
          <v-btn 
            :to="`/providers/${providerId}`" flat small color="primary" 
            class="mt-0 mb-0 mr-0"
          >
            <v-icon class="mr-2">school</v-icon>
            Go to provider
          </v-btn>
          <our-next-previous-navigator
            :nav-url="`/levy-collections/${levyCollectionId}/providers/:id/history`"
            :next-page-action="nextPageAction"
            :previous-page-action="previousPageAction"
            id-field="providerId"
            module="levyCollectionProviders"
            class="mb-0"
          />
        </div>
      </template>
      <template v-slot:prefix>
        <favourite-indicator :provider="provider" />
      </template>
      <template v-slot:navigator>
        <levy-collection-navigator :levy-collection-id="levyCollectionId" :sandbox="isSandbox" />
      </template>
    </our-heading>
    <tabs :levy-collection-id="levyCollectionId" :provider-id="providerId">
      <history-timeline-toggle
        v-model="timeline" 
        :ascending.sync="ascending" 
        :status-changes-only.sync="statusChangesOnly"
        @click:search="showSearchDialog = true"
        @click:expand="$refs.timeline.expandAll()"
        @click:collapse="$refs.timeline.collapseAll()"
        @changed="$refs.history.refresh()"
      />
      <history-timeline 
        v-if="levyCollectionLoaded && providerLoaded && timeline"
        ref="timeline"
        :provider-id="providerId"
        :levy-collection-id="levyCollectionId"
        :provider-name="`${provider.providerName} (${provider.providerCode})`"
        :levy-collection-name="levyCollectionName"
        :ascending="ascending"
        :status-changes-only="statusChangesOnly"
      />
      <system-log-listing
        v-if="levyCollectionLoaded && providerLoaded && !timeline"
        ref="history"
        :endpoint="`/api/levy-collections/${levyCollectionId}/providers/${providerId}/history`"
        :export-endpoint="`/api/exports/levy-collections/${levyCollectionId}/providers/${providerId}/history`"
        :export-validate-endpoint="`/api/exports/validate/levy-collections/${levyCollectionId}/providers/${providerId}/history`"
        embedded simple
      />
    </tabs>
  </div>
</template>

<script>
import Tabs from "./Tabs.vue";
import FavouriteIndicator from "@/components/levy-collection-providers/FavouriteIndicator.vue";
import LevyCollectionNavigator from "@/components/levy-collections/LevyCollectionNavigator.vue";
import SystemLogListing from "@/components/system-logs/SystemLogListing.vue";
import HistoryTimeline from "@/components/levy-collection-providers/HistoryTimeline.vue";
import HistoryTimelineToggle from "@/components/levy-collection-providers/HistoryTimelineToggle.vue";
import mixins from "./mixins";
import lookupMixins from "@/mixins/lookup.mixins";

export default {
  name: "LevyCollectionProviderHistory",
  components: {
    SystemLogListing,
    FavouriteIndicator,
    LevyCollectionNavigator,
    Tabs,
    HistoryTimeline,
    HistoryTimelineToggle
  },
  mixins: [mixins, lookupMixins],
  data() {
    return {
      timeline: true,
      ascending: true,
      statusChangesOnly: false
    };
  },
  computed: {
    levyCollectionName() {
      const lc = this.levyCollection;
      return `${lc.year} ${this.lookups.levyCollectionTypeDescriptions[lc.type]}`;
    }
  }
};
</script>
